/**
 * Todo: normalize tablets in-between,
 * remember to update tw config when refactored
 */
export const MAX_BREAKPOINTS = {
  LARGE_SCREEN: 1535,

  LAPTOP: 1300,

  TABLET: 1090,

  SMALL_TABLET: 767,

  PHONE: 534,

  SMALL_PHONE: 390,
};

type Breakpoints = typeof MAX_BREAKPOINTS;

export type ResponsiveBreakpoint = keyof Breakpoints;
